import '@fontsource/manrope/400.css';
import '@fontsource/manrope/500.css';
import '@fontsource/manrope/600.css';
import '@fontsource/manrope/700.css';

import '@material/web/button/filled-button.js';
import '@material/web/button/filled-tonal-button.js';
import '@material/web/button/outlined-button.js';
import '@material/web/chips/assist-chip.js';
import '@material/web/chips/filter-chip.js';
import '@material/web/divider/divider.js';
import '@material/web/iconbutton/icon-button.js';
import '@material/web/textfield/outlined-text-field.js';

import '../css/app.css';

const body = document.body;

const closeSidebar = () => body.classList.remove('sidebar-open');
const toggleSidebar = () => body.classList.toggle('sidebar-open');
const highcharts = window.Highcharts;

document.querySelectorAll('[data-sidebar-toggle]').forEach((element) => {
  element.addEventListener('click', toggleSidebar);
});

document.querySelectorAll('[data-sidebar-close]').forEach((element) => {
  element.addEventListener('click', closeSidebar);
});

window.addEventListener('resize', () => {
  if (window.innerWidth > 1120) {
    closeSidebar();
  }
});

const parseDataset = (value, fallback = []) => {
  if (!value) {
    return fallback;
  }

  try {
    return JSON.parse(value);
  } catch {
    return fallback;
  }
};

const chartPalette = ['#1a0808', '#c7a56b', '#e4d7ce', '#8d6b3f', '#fbf5ef'];

const renderBarCharts = () => {
  if (!highcharts) {
    return;
  }

  document.querySelectorAll('[data-chart="bar"]').forEach((element) => {
    const categories = parseDataset(element.dataset.categories);
    const series = parseDataset(element.dataset.series);

    highcharts.chart(element, {
      chart: {
        type: 'column',
        backgroundColor: 'transparent',
        spacing: [12, 8, 12, 8],
        style: {
          fontFamily: 'Manrope, Segoe UI, sans-serif',
          fontWeight: '400',
        },
      },
      title: { text: undefined },
      credits: { enabled: false },
      legend: {
        align: 'left',
        itemStyle: {
          color: '#665952',
          fontWeight: '400',
          textOutline: 'none',
        },
      },
      xAxis: {
        categories,
        lineColor: '#e4d7ce',
        tickColor: '#e4d7ce',
        labels: {
          style: {
            color: '#8a7d75',
            fontSize: '12px',
            fontWeight: '400',
            textOutline: 'none',
          },
        },
      },
      yAxis: {
        title: { text: undefined },
        gridLineColor: 'rgba(228, 215, 206, 0.8)',
        labels: {
          style: {
            color: '#8a7d75',
            fontSize: '12px',
            fontWeight: '400',
            textOutline: 'none',
          },
        },
      },
      tooltip: {
        borderRadius: 16,
        borderColor: '#e4d7ce',
        backgroundColor: '#fffdfa',
        shadow: false,
      },
      plotOptions: {
        column: {
          borderRadius: 10,
          pointPadding: 0.12,
          groupPadding: 0.16,
        },
        series: {
          animation: false,
        },
      },
      colors: chartPalette.slice(0, 2),
      series,
    });
  });
};

const renderPieCharts = () => {
  if (!highcharts) {
    return;
  }

  document.querySelectorAll('[data-chart="pie"]').forEach((element) => {
    const data = parseDataset(element.dataset.series);

    highcharts.chart(element, {
      chart: {
        type: 'pie',
        backgroundColor: 'transparent',
        spacing: [8, 8, 8, 8],
        style: {
          fontFamily: 'Manrope, Segoe UI, sans-serif',
          fontWeight: '400',
        },
      },
      title: { text: undefined },
      credits: { enabled: false },
      tooltip: {
        pointFormat: '{point.y} conversas',
        borderRadius: 16,
        borderColor: '#e4d7ce',
        backgroundColor: '#fffdfa',
        shadow: false,
      },
      plotOptions: {
        pie: {
          innerSize: '62%',
          borderWidth: 0,
          dataLabels: {
            enabled: true,
            format: '{point.name}',
            style: {
              fontSize: '11px',
              fontWeight: '400',
              color: '#665952',
              textOutline: 'none',
            },
          },
        },
        series: {
          animation: false,
        },
      },
      colors: chartPalette,
      series: [
        {
          name: 'Conversas',
          data,
        },
      ],
    });
  });
};

renderBarCharts();
renderPieCharts();
